export const ANCHOR_IDS = {
  ABANDONED_CHECKOUT_REMINDERS: 'abandoned-checkout-reminders',
}
